
import { Button, ButtonGroup, Divider, Grid, Typography } from '@mui/material'
import { Box, Stack } from '@mui/system'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { BOOKING_TYPE, SELECTED_VEHICLE, SET_SELECTED_BOOKING } from '../../../Redux/constants/bookingConstants'
import Vehicle from './Vehicle'

const MyTransfer = () => {

    const { vehicleAvailability } = useSelector(state => state.mytransfer)


    


    return (
        <div>
            {vehicleAvailability?.transferPriceList && vehicleAvailability?.transferPriceList.length > 0 ? (
                 <Grid container spacing={4}  mt={0}>
                    {vehicleAvailability.transferPriceList.map((vehicle, index) => {
                        return(
                            <Grid id={index} item  xs={12} md={6} lg={6}  >
                                <Vehicle 
                                    item={vehicle}
                                />
                            </Grid>
                        )
                    })}
                </Grid>
            ) : (
                <div style={{display:'flex',justifyContent:'center'}} >
                    <Typography fontFamily={'Nunito'} fontSize={20} fontWeight={'bold'} letterSpacing={1}>
                        No Vehicle Found !
                    </Typography>
                 </div>
            )}
        </div>
    )
}

export default MyTransfer